export type SupportedLanguage = "en-CA" | "fr-CA";

export interface ITranslateObject extends Record<SupportedLanguage, string> {}

export class TranslateObject implements ITranslateObject {
    "en-CA" = "";
    "fr-CA" = "";
}
